import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import AlertBox from 'components/AlertBox/AlertBox'
import HFTextInput from 'components/HFInputs/HFTextInput'

import styles from '../../Dialog.module.sass'

export const ClientPhoneNumberField = () => {
	const { i18n } = useGlobal()

	return (
		<fieldset>
			<h4>{i18n`Client phone number`}</h4>
			<AlertBox
				className={styles['alert-box']}
				type='warning'
				items={[
					{
						title: i18n`Warning`,
						text: i18n`The client has no registered phone number. Enter a mobile phone number so the client can be notified by SMS when the task is submitted.`,
					},
				]}
			/>
			<VStack className={styles['form-input']}>
				<h5>{i18n`Phone nr.`}</h5>
				<HFTextInput name='client.phoneNumber' type='number' />
			</VStack>
		</fieldset>
	)
}
